import { fetchJson } from './apiClient';

export type AudienceBucket = 'my-leads' | 'all-connections' | 'professional-network' | 'local-contacts' | 'recent-connections';

export type AudienceItem = {
  userId?: string;
  leadId?: string;
  source: 'user' | 'lead' | 'device';
  name: string;
  phone: string;
  matching?: { company?: boolean; position?: boolean; keywords?: string[] };
};

export async function getAudience(params: { ownerId: string; bucket: AudienceBucket; mutualOnly?: boolean; recentDays?: number; limit?: number; cursor?: string; }) {
  const q = new URLSearchParams();
  q.set('ownerId', params.ownerId);
  q.set('bucket', params.bucket);
  if (params.mutualOnly) q.set('mutualOnly', 'true');
  if (params.recentDays) q.set('recentDays', String(params.recentDays));
  if (params.limit) q.set('limit', String(params.limit));
  if (params.cursor) q.set('cursor', params.cursor);
  return fetchJson(`/api/broadcast/audience?${q.toString()}`);
}

export async function prepareBroadcast(body: { ownerId: string; bucket: AudienceBucket; mutualOnly?: boolean; recentDays?: number; }) {
  return fetchJson('/api/broadcast/prepare', { method: 'POST', body: JSON.stringify(body) });
}
